var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChatDotorder = function SvgChatDotorder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66667 9.625C2.90583 9.625 2.29167 10.2392 2.29167 11C2.29167 11.7608 2.90583 12.375 3.66667 12.375C4.4275 12.375 5.04167 11.7608 5.04167 11C5.04167 10.2392 4.4275 9.625 3.66667 9.625ZM3.66667 4.125C2.90583 4.125 2.29167 4.73917 2.29167 5.5C2.29167 6.26083 2.90583 6.875 3.66667 6.875C4.4275 6.875 5.04167 6.26083 5.04167 5.5C5.04167 4.73917 4.4275 4.125 3.66667 4.125ZM3.66667 15.125C2.90583 15.125 2.29167 15.7483 2.29167 16.5C2.29167 17.2517 2.915 17.875 3.66667 17.875C4.41833 17.875 5.04167 17.2517 5.04167 16.5C5.04167 15.7483 4.4275 15.125 3.66667 15.125ZM6.41667 17.4167H19.25V15.5833H6.41667V17.4167ZM6.41667 11.9167H19.25V10.0833H6.41667V11.9167ZM6.41667 4.58333V6.41667H19.25V4.58333H6.41667Z",
    fill: "#8F97B9"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChatDotorder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat_dotorder.0cb91b6b.svg";
export { ForwardRef as ReactComponent };